import { TikTokEmbed } from 'react-social-media-embed';

const TikTokModule = (props) => {

  const { module, windowWidth } = props;

  if (module.value && module.value !== '') {
    return (
      <div className='module module--video' style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <TikTokEmbed url={ module.value } width={Math.min(windowWidth - 80, 640)} />
      </div>
    );
  } else {
    return null;
  }
}

export default TikTokModule;